import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { distinctUntilChanged, retry, catchError } from 'rxjs/operators';
import { SCREEN_SIZE, TTGAPairingGridResults } from '../Models/common.model';

@Injectable({
  providedIn: 'root'
})
export class TtgaPairingService {
    private apiURL = window.location.href.split('?')[0];
    private queryParams = (window.location.href.split('?').length > 1) ? window.location.href.split('?')[1] : "";
    private api = window.location.origin;

    get onResize$(): Observable<SCREEN_SIZE> {
        return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
    }

    private resizeSubject: Subject<SCREEN_SIZE>;

    onResize(size: SCREEN_SIZE) {
        this.resizeSubject.next(size);
    }

    constructor(private http: HttpClient) {
        this.resizeSubject = new Subject();
    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    getTTGAPairingDetails(): Observable<TTGAPairingGridResults[]> {
        return this.http.get<TTGAPairingGridResults[]>(this.api + '/Api/SwapaApi/GetTTGAGridDetails?dom=test')
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    deleteDTCMultiplePreferences(ids: number[]): Observable<any> {
        const url = `${this.api}/LineTunerDTCPreferencesBlock/DeleteMultipleDTCPreferences`;
        return this.http.post(url, { ids }, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    deleteNetZeroMultiplePreferences(ids: number[]): Observable<any> {
        const url = `${this.api}/LineTunerNetZeroPreferencesBlock/DeleteMultipleNetZeroPreferences`;
        return this.http.post(url, { ids }, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    deleteTTGAMultiplePreferences(ids: number[]): Observable<any> {
        const url = `${this.api}/LineTunerTTGAPairingBlock/DeleteMultiplePreferences`;
        return this.http.post(url, { ids }, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
